import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaUsers, FaChartLine, FaHistory, FaExchangeAlt, FaMoneyBillWave } from 'react-icons/fa';

const BottomNavigation = () => {
  const location = useLocation();
  
  // Inline styles for the component
  const styles = {
    container: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      height: '70px',
      background: 'linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)',
      borderTop: '1px solid rgba(255, 255, 255, 0.1)',
      boxShadow: '0 -4px 10px rgba(0, 0, 0, 0.25)',
      zIndex: 1000
    },
    item: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#8BADC2',
      width: '20%',
      textDecoration: 'none',
      transition: 'all 0.3s ease',
      position: 'relative',
      padding: '8px 0'
    },
    activeItem: {
      color: '#38EFF9'
    },
    activeIndicator: {
      content: '""',
      position: 'absolute',
      bottom: 0,
      width: '30px',
      height: '3px',
      background: '#38EFF9',
      borderRadius: '2px',
      boxShadow: '0 0 8px rgba(56, 239, 249, 0.6)'
    },
    icon: {
      fontSize: '22px',
      marginBottom: '4px',
      transition: 'transform 0.2s ease'
    },
    hoverIcon: {
      transform: 'translateY(-2px)'
    },
    label: {
      fontSize: '11px',
      fontWeight: 500
    },
    tradeIcon: {
      background: 'linear-gradient(135deg, #00DBDE 0%, #FC00FF 100%)',
      borderRadius: '50%',
      width: '44px',
      height: '44px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 2px 10px rgba(0, 219, 222, 0.5)',
      transform: 'translateY(-10px)',
      border: '3px solid #0f2027',
      transition: 'all 0.3s ease'
    },
    tradeInnerIcon: {
      fontSize: '22px',
      color: '#0f2027'
    },
    tradeLabel: {
      marginTop: '8px'
    }
  };
  
  // Hover state hooks
  const [hoveredItem, setHoveredItem] = React.useState(null);
  
  return (
    <nav style={styles.container}>
      <Link
        to="/portfolio"
        style={{
          ...styles.item,
          ...(location.pathname === '/portfolio' ? styles.activeItem : {}),
        }}
        onMouseEnter={() => setHoveredItem('account')}
        onMouseLeave={() => setHoveredItem(null)}
      >
        <div style={{
          ...styles.icon,
          ...(hoveredItem === 'account' ? styles.hoverIcon : {})
        }}>
          <FaChartLine />
        </div>
        <span style={styles.label}>Portfolio</span>
        {location.pathname === '/portfolio' && <div style={styles.activeIndicator}></div>}
      </Link>
      <Link
        to="/mining-packages"
        style={{
          ...styles.item,
          ...(location.pathname === '/mining-packages' ? styles.activeItem : {}),
        }}
        onMouseEnter={() => setHoveredItem('devices')}
        onMouseLeave={() => setHoveredItem(null)}
      >
        <div style={{
          ...styles.tradeIcon,
          ...(hoveredItem === 'devices' ? { transform: 'translateY(-14px) scale(1.05)' } : {})
        }}>
          <FaExchangeAlt style={styles.tradeInnerIcon} />
        </div>
        <span style={{...styles.label, ...styles.tradeLabel}}>Trade</span>
        {location.pathname === '/mining-packages' && <div style={styles.activeIndicator}></div>}
      </Link>
      <Link
        to="/buyings"
        style={{
          ...styles.item,
          ...(location.pathname === '/buyings' ? styles.activeItem : {}),
        }}
        onMouseEnter={() => setHoveredItem('buyings')}
        onMouseLeave={() => setHoveredItem(null)}
      >
        <div style={{
          ...styles.icon,
          ...(hoveredItem === 'buyings' ? styles.hoverIcon : {})
        }}>
          <FaHistory />
        </div>
        <span style={styles.label}>History</span>
        {location.pathname === '/buyings' && <div style={styles.activeIndicator}></div>}
      </Link>
      <Link
        to="/transactions"
        style={{
          ...styles.item,
          ...(location.pathname === '/transactions' ? styles.activeItem : {}),
        }}
        onMouseEnter={() => setHoveredItem('transactions')}
        onMouseLeave={() => setHoveredItem(null)}
      >
        <div style={{
          ...styles.icon,
          ...(hoveredItem === 'transactions' ? styles.hoverIcon : {})
        }}>
          <FaMoneyBillWave />
        </div>
        <span style={styles.label}>Profits</span>
        {location.pathname === '/transactions' && <div style={styles.activeIndicator}></div>}
      </Link>
      <Link
        to="/referrals"
        style={{
          ...styles.item,
          ...(location.pathname === '/referrals' ? styles.activeItem : {}),
        }}
        onMouseEnter={() => setHoveredItem('referrals')}
        onMouseLeave={() => setHoveredItem(null)}
      >
        <div style={{
          ...styles.icon,
          ...(hoveredItem === 'referrals' ? styles.hoverIcon : {})
        }}>
          <FaUsers />
        </div>
        <span style={styles.label}>Referrals</span>
        {location.pathname === '/referrals' && <div style={styles.activeIndicator}></div>}
      </Link>
    </nav>
  );
};

export default BottomNavigation;